export default "/images/synergy.png";